<template>
  <el-table-column
    prop="source_user_name"
    sortable="custom"
    label="Forrás képviselő"
    show-overflow-tooltip
    min-width="180"
  >
    <template slot-scope="scope">
      {{ scope.row.source_user_name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'source_user_name',
  };
</script>
